import { createStore } from 'vuex'
import axios from "axios";
import {soilmapUrl, uncertaintymapUrl} from "@/data";

export const store = createStore({
    state () {
        return {
            layerGroup: null,
            layer: null,
            legend: null,
            legendUncertainty: null,
            showUncertaintyLayer: false,
            opacity: 100,
            token: null,
            language: 0
        }
    },
    getters: {
        currentLegend(state) {
            return state.legend.find(lg => lg.layerId === state.layer.id)
        },
        currentUncertaintyLegend(state) {
          return state.legendUncertainty.find(lg => lg.layerId === state.layer.id)
        },
        currentLanguage(state) {
            return state.language
        }
    },
    mutations: {
        setOpacity(state, value) {
          state.opacity = value
        },
        setLayerGroup (state, layerGroup) {
            state.layerGroup = layerGroup
            if (layerGroup) {
                state.layer = state.layerGroup.subLayers.length > 0 ? state.layerGroup.subLayers[0] : state.layerGroup
            }
        },
        setLayer (state, layer) {
            console.log(layer)
            state.layer = layer
        },
        setToken (state, token) {
            state.token = token
        },
        showUncertaintyLayer(state, value) {
            state.showUncertaintyLayer = value
        },
        setLegend(state, value) {
            state.legend = value
        },
        setLegendUncertainty(state, value) {
            state.legendUncertainty = value
        },
        setLanguage(state, value) {
            state.language = value
        }
    },
    actions: {
        getLegend ({ commit }, language) {
            let mapservice = soilmapUrl.de + '/legend?f=pjson'
            let umapUrl = uncertaintymapUrl.de + '/legend?f=pjson'
            let lang = language
            if(lang == 0) {
                mapservice = soilmapUrl.de + '/legend?f=pjson'
                umapUrl = uncertaintymapUrl.de + '/legend?f=pjson'
            } else if (lang == 1)  {
                mapservice = soilmapUrl.fr + '/legend?f=pjson'
                umapUrl = uncertaintymapUrl.fr + '/legend?f=pjson'

            } else if (lang == 2) {
                mapservice = soilmapUrl.en + '/legend?f=pjson'
                umapUrl = uncertaintymapUrl.en + '/legend?f=pjson'
            }
            axios.get(mapservice)
                .then(res => commit('setLegend', res.data.layers))
            axios.get(umapUrl)
                .then(res => commit('setLegendUncertainty', res.data.layers))
        }
    }
})
